import React, { FC } from 'react';

import { Icon } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import MenuSectionHeading from 'components/menu-section-heading';
import { RewardsCarousel } from 'components/rewards-carousel';

import {
  HeaderLink,
  HeaderTextWrapper,
  IconWrapper,
  RewardsSectionContainer,
} from './rewards-section.styled';
import { IRewardsSectionViewProps } from './types';

export const RewardsSectionView: FC<IRewardsSectionViewProps> = ({ rewards }) => {
  const { formatMessage } = useIntl();
  const rewardsPath = `${formatMessage({ id: 'routes.loyaltyHome' })}/list`;
  return (
    <RewardsSectionContainer>
      <MenuSectionHeading as="h2">
        <HeaderTextWrapper>
          {formatMessage({ id: 'rewards' })}
          <HeaderLink to={rewardsPath}>
            {formatMessage({ id: 'viewAll' })}
            <IconWrapper>
              <Icon icon="arrowRight" color="primary" width="0.6em" />
            </IconWrapper>
          </HeaderLink>
        </HeaderTextWrapper>
      </MenuSectionHeading>
      <RewardsCarousel rewards={rewards} />
    </RewardsSectionContainer>
  );
};
